import ThisModule from "./PricesTable";

export default ThisModule;
